import React, {useEffect, useState} from "react";
import {
    Box,
    Button,
    Container,
    TextField,
    CssBaseline,
    Typography, Alert, Fade, Collapse, Snackbar
} from "@mui/material";

import {login} from "../../features/users/Users";
import Logo from "../Logo";

function Login() {


    const [open, setOpen] = useState(false);


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    useEffect(() => {


    }, []);
    const handleSubmit = async (event) => {

        event.preventDefault();
        const formData = new FormData(event.currentTarget);

        const loginCredentials = {
            email: formData.get('email'),
            password: formData.get('password')
        }


        login(loginCredentials).then((r) => {
            if (r === false) {

                setOpen(true)

            }


        })


    }


    return (
        <Container maxWidth={"xs"}>
            <CssBaseline/>
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>
                <Typography component={"h1"} variant={"h5"}>
                    <Logo/>
                </Typography>


                <Snackbar open={open} autoHideDuration={6000} onClose={() => handleClose}>
                    <Alert onClose={() => handleClose} severity="error" sx={{width: '100%'}}>
                        Login Failed! User or Password Incorrect!
                    </Alert>
                </Snackbar>

                <Box component={"form"} onSubmit={handleSubmit}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="E-mail"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        type='email'
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                    />
                    <Button
                        fullWidth
                        variant={"outlined"}
                        type={"submit"}
                        sx={{mt: 3, mb: 2}}
                    >
                        Login
                    </Button>
                </Box>
            </Box>
        </Container>
    )
}

export default Login